export const RESPONSIVE_MODE_CHANGE = 'RESPONSIVE_MODE_CHANGE';
